import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import LoadingAdapter from '../../libs/utils/LoadingAdapter';
import axios from 'axios';
import useToken from '../../components/auth/useToken';
import api from '../../libs/utils/axiosApiInstance'
const initialState = {
  agent: null,
  token: localStorage.getItem('token') || null,
  requestNo: localStorage.getItem('requestNo') || null
}


// export function timeout(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }


export const getAgentProfile = createAsyncThunk(
  "profile/getFriends",
  async () => {
    try {
      if(initialState.token) {
      const res = await api.get(`/profile/agents/${initialState.requestNo}`, { headers: { "Authorization": `Bearer ${initialState.token}` } });
      const json = await res.data.result
 
      return json;
      }
 
    } catch (error) {
    
      throw new Error('test')
    }
   
  }
);

export const profileSlice = createSlice({
  name: 'profile',
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    updateProfile: (state, action) => {
      state.agent = action.payload;
    },
    clearAll: () => LoadingAdapter.getInitialState(initialState),
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getAgentProfile, builder, ['agent']);

    // builder
    //   .addCase(getFriends.pending, (state, action) => {
    //     console.log('pending');
    //     state.isLoading = true;
    //   })
    //   .addCase(getFriends.fulfilled, (state, action) => {
    //     console.log('fulfilled');
    //     state.isLoading = false;
    //     state.isSuccess = true;
    //     state.isFailure = false;
    //   })
    //   .addCase(getFriends.rejected, (state, action) => {
    //     console.log('rejected');
    //     state.isLoading = false;
    //     state.isSuccess = false;
    //     state.isFailure = true;
    //     state.error = 'load failed';
    //   })
  },
})

// Action creators are generated for each case reducer function
export const { updateProfile, clearAll } = profileSlice.actions

export default profileSlice.reducer